export default {
  styleOverrides: {
    root: () =>
      ({
        padding: '0px 20px 20px 20px',
      }),
  },
};
